/* eslint-disable no-shadow */
import React, { FC, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import { useAuth, useAnalytics } from 'reactfire'
import * as Yup from 'yup'

import {
  LogInHeader,
  ModalText,
  InputLabel,
  InputError,
} from '../../../components/Typography'
import { Button } from '../../../components/Button'
import { ProgressBar } from '../../../components/ProgressBar'
import { LoadingScreen } from '../../../components/Loading'
import { MAGIC_LINK } from '../../../constants/routes'
import { actionCodeSettings } from '../../../constants/firebase'
import { StyledForm, StyledInput } from '../styled'

import { Wrap } from './styled'

import { EmailForSignInKey } from 'src/constants/localStorageKeys'
import { analyticsEvents } from 'src/constants/analytics/events'

const EmailInput: FC = () => {
  const auth = useAuth()
  const { logEvent } = useAnalytics()

  const historyHook = useHistory()

  const [disabledForm, setDisabledForm] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [authError, setAuthError] = React.useState<string>()

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Please enter a valid email address')
        .required('Email is required'),
    }),
    onSubmit: async (values) => {
      setIsLoading(true)
      window.localStorage.setItem(EmailForSignInKey, values.email)
      try {
        await auth.sendSignInLinkToEmail(values.email, actionCodeSettings)
        logEvent(analyticsEvents.onboardingEmailEntered)
        historyHook.push(MAGIC_LINK)
      } catch (e) {
        if (e.code === 'auth/user-disabled') {
          return setAuthError('This user is disabled')
        }
        setAuthError('Error during sending magic email occurred')
      }
    },
  })

  useEffect(() => {
    formik.values.email.length > 3 && formik.isValid
      ? setDisabledForm(false)
      : setDisabledForm(true)
  }, [formik.isValid, formik.values.email])

  return (
    <Wrap>
      {isLoading && !authError && <LoadingScreen />}
      <ProgressBar progress={10} />
      <LogInHeader>What’s your email?</LogInHeader>
      <ModalText>To create an account or log in enter your email</ModalText>
      <StyledForm onSubmit={formik.handleSubmit}>
        <InputLabel htmlFor="email">Email</InputLabel>
        <StyledInput
          id="email"
          name="email"
          type="email"
          placeholder="john.doe@example.com"
          onChange={formik.handleChange}
          value={formik.values.email}
          onBlur={formik.handleBlur}
          isError={formik.touched.email && formik.errors.email ? true : false}
        />
        {formik.touched.email && formik.errors.email && (
          <InputError>{formik.errors.email}</InputError>
        )}
        {authError && <InputError>{authError}</InputError>}
        <Button type="submit" label="Continue" disabled={disabledForm} />
      </StyledForm>
    </Wrap>
  )
}

export default EmailInput
